/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { motion as m, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { getDataByAll } from "../../api/heroApi";

// Import Sub-Components
import HeroBanner from "../Common/HeroBanner";
import HeroClinicalActivities from "../Common/HeroClinicalActivities";

const Hero = () => {
  const [datas, setDatas] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDataByAll().then((res) => {
      setDatas(res);
      setLoading(false);
    });
  }, []);

  if (loading || !datas) return <section className="min-h-screen bg-slate-950 flex items-center justify-center text-white font-black uppercase tracking-widest">Loading Event...</section>;

  return (
    /* 
       PENGATURAN TINGGI TOTAL:
       - Hapus 'min-h-screen'
       - Gunakan 'h-auto' agar tinggi Hero pas mengikuti gabungan Banner + Clinical Activities
    */
    <section className="relative h-auto flex flex-col overflow-hidden">
      
      {/* Bagian 1: Banner (Tinggi diatur di dalam komponen ini) */}
      <HeroBanner data={datas} />

      {/* Bagian 2: Clinical Activities */}
      <HeroClinicalActivities />

      {/* 
          Global Scroll Indicator (Opsional)
          Jika tingginya sudah pendek, indicator ini mungkin tidak diperlukan lagi.
      */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-slate-400 z-20 hidden md:block">
        <m.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 2 }}>
          <ChevronDown size={24} strokeWidth={1} />
        </m.div>
      </div>
    </section>
  );
};

export default Hero;